import useAlertDialog from "../../../hooks/useAlertDialog";
import { AlertType } from "../../../hooks/common/useAttachAlertDialog";
import { banUserAdmin, unbanUserAdmin } from "../../../../services/UserService";

const MIN_BAN_REASON = 20;

export default function useBanUserAdmin(props: { reload: () => void }) {
	const { openAlertDialog } = useAlertDialog();

	const banUserAd = async (id: string, reason: string) => {
		const trimmed = typeof reason === "string" ? reason.trim() : "";
		if (trimmed.length < MIN_BAN_REASON) {
			openAlertDialog?.(
				AlertType.Fail,
				`Ban reason must be at least ${MIN_BAN_REASON} characters.`,
			);
			return;
		}
		try {
			await banUserAdmin(id, trimmed);
			openAlertDialog?.(AlertType.Success, "User banned.", () => {
				props.reload();
			});
		} catch (err: unknown) {
			const msg =
				err && typeof err === "object" && "response" in err
					? (err as { response?: { data?: { message?: string } } }).response?.data?.message
					: undefined;
			openAlertDialog?.(AlertType.Fail, msg || "Ban failed.");
		}
	};

	const unbanUserAd = async (id: string) => {
		try {
			await unbanUserAdmin(id);
			openAlertDialog?.(AlertType.Success, "User unbanned.", () => {
				props.reload();
			});
		} catch (err: unknown) {
			const msg =
				err && typeof err === "object" && "response" in err
					? (err as { response?: { data?: { message?: string } } }).response?.data?.message
					: undefined;
			openAlertDialog?.(AlertType.Fail, msg || "Unban failed.");
		}
	};

	return {
		banUserAd,
		unbanUserAd,
		MIN_BAN_REASON,
	};
}
